import { FC, useEffect, useState } from 'react'
import styles from './MultipleChoice.module.css'
import { OnResponseSubmit, Option, StepResponse } from '../../../types/Exercise'
import { t } from 'i18next'

interface MultipleChoiceProps {
  id: number
  data: {
    maximumAllowedAnswers: number
    options: Option[]
  }
  onResponseSubmit: OnResponseSubmit
  stepResponse?: StepResponse
}

const MultipleChoice: FC<MultipleChoiceProps> = ({
  id,
  data,
  onResponseSubmit,
  stepResponse,
}) => {
  const { maximumAllowedAnswers, options } = data
  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    stepResponse?.response || [],
  )
  const [optionsHasBeenSelected, setOptionsHasBeenSelected] =
    useState<boolean>(false)

  const handleOptionClick = (selection: string) => {
    const selectedOptionIndex = selectedOptions.findIndex(
      (option) => option === selection,
    )

    if (selectedOptionIndex !== -1) {
      selectedOptions.splice(selectedOptionIndex, 1)
      setSelectedOptions([...selectedOptions])
    } else {
      const options = [selection, ...selectedOptions].slice(
        0,
        maximumAllowedAnswers,
      )
      setSelectedOptions(options)
    }

    setOptionsHasBeenSelected(true)
  }

  useEffect(() => {
    setSelectedOptions(stepResponse?.response || [])
  }, [stepResponse?.response])

  // selectedOptions could be empty only when user selected back the same option and we update array.
  // optionsHasBeenSelected prevent sending empty response on first render
  useEffect(() => {
    if (optionsHasBeenSelected) onResponseSubmit(id, selectedOptions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions])

  const getOptionStyle = (selection: string) => {
    if (selectedOptions.includes(selection)) {
      return styles.selectedOption
    }
    return ''
  }

  return (
    <div className={styles.optionsContainer}>
      {options.map(({ option }, index) => {
        return (
          <div
            key={index}
            className={`${styles.option} ${getOptionStyle(option)}`}
            onClick={() => handleOptionClick(option)}
          >
            <p>{option}</p>
          </div>
        )
      })}
      <p className={styles.max}>
        {t('exercises.maximumAnswers', { maximumAllowedAnswers })}
      </p>
    </div>
  )
}

export default MultipleChoice
